/* import __COLOCATED_TEMPLATE__ from './buyer-menu.hbs'; */
import Component from '@glimmer/component';
import constants from 'sh-www/constants';

const {
  BUYER_ROUTE_PARENT_NAME__PRIMARY_ROUTE_MAP,
  BUYER_ROUTE_PARENT_NAMES,
} = constants;

const route = (name) => BUYER_ROUTE_PARENT_NAME__PRIMARY_ROUTE_MAP[name].route;

class BuyerSideNavComponent extends Component {
  get postingsRoute() {
    return route(BUYER_ROUTE_PARENT_NAMES.STORIES);
  }

  get peopleRoute() {
    return route(BUYER_ROUTE_PARENT_NAMES.PEOPLE);
  }

  get messagesRoute() {
    return route(BUYER_ROUTE_PARENT_NAMES.MESSAGES);
  }

  get reportsRoute() {
    return route(BUYER_ROUTE_PARENT_NAMES.REPORTS);
  }
}

export default BuyerSideNavComponent;
